import * as Icon from "react-bootstrap-icons";
import { VscReferences } from "react-icons/vsc";

const user_id = localStorage.getItem("userid");













let storedNumber = localStorage.getItem('helplinenumber') || '';

  storedNumber = storedNumber.replace(/\D/g, ''); // Remove non-digits like +, space, etc.



  const validWhatsAppLink = storedNumber.length >= 10

    ? `https://wa.me/${storedNumber}`

    : "#";









 const Sidebardata = [
  {
    title: "Profile",
    path: "/Profile",
    icon: <Icon.PersonCircle />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
  {
    title: "My Commission",
    path: "/Appdetails",
    icon: <Icon.Phone />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
  {
    title: "Transfer Point",
    path: "/Transferrespoint",
    icon: <Icon.CurrencyRupee />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
  {
    title: "Transfer Point List",
    path: "/Transferrespointlist",
    icon: <Icon.CurrencyRupee />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
  {
    title: "Game History",
    path: "/History",
    icon: <Icon.ClockHistory />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
  {
    title: "Result History",
    path: "/Resulthistory",
    icon: <Icon.HourglassSplit />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
  {
    title: "Terms And Condition",
    path: "/Termsandcondition",
    icon: <Icon.JournalCheck />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
  // {
  //   title: "my Refer List",
  //   path: "/Refer",
  //   icon: <VscReferences />,
  //   ownclass: "d-flex align-items-center link-page navlink-design",
  // },
{

      title: "whatsapp Number",

      path: validWhatsAppLink,

      icon: <Icon.Phone />,

      ownclass: "d-flex align-items-center link-page navlink-design",

    },
  {
    title: "Logout",
    // path:"/Login",
    icon: <Icon.BoxArrowLeft />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
];


export default Sidebardata;